import { Balance, BalanceTransaction, Company } from '@/@data'
import { BoxPage } from '@/components/common/BoxPage'
import { BalanceCompanyDetailCurrent } from '@/components/finance/balance/BalanceCompanyDetailCurrent'
import { BalanceCompanyDetailPast } from '@/components/finance/balance/BalanceCompanyDetailPast'
import { BalanceFilterBarDetail } from '@/components/finance/balance/BalanceFilterBarDetail'
import { useRouteQuery } from '@/hooks'
import { useQuery } from '@tanstack/react-query'

import dayjs from 'dayjs'

export const BalanceDetail = () => {
  const { __ } = useTranslator()
  const { id } = useParams()
  const { searchQuery, serializeQuery } = useRouteQuery()

  const month = searchQuery.get('month')

  const params = useMemo(() => {
    return {
      year: searchQuery.get('month')?.substring(0, 4),
      month: searchQuery.get('month')?.substring(5, 7),
      company_id: id
    }
  }, [searchQuery])

  const { data: dataBalanceStatisticsCompare } = useQuery({
    ...Balance.getBalanceStatisticsCompare(params),
    enabled: !!id
  })

  const { data: dataCompany } = useQuery({
    ...Company.getCompanyById(Number(id)),
    enabled: !!id
  })

  const { data: dataBalanceStatistics } = useQuery({
    ...Balance.getBalanceStatisticsCard(params),
    enabled: !!id
  })

  const paramsBalanceTransaction = useMemo(
    () =>
      serializeQuery({
        page: searchQuery.get('page'),
        perPage: searchQuery.get('perPage'),
        month: searchQuery.get('month'),
        company_id: id,
        status: searchQuery.get('status'),
        creator: searchQuery.get('creator'),
        approve_at_from: searchQuery.get('approve_at_from'),
        approve_at_to: searchQuery.get('approve_at_to')
      }),
    [searchQuery]
  )

  const { data: dataBalanceTransaction, refetch: refetchBalanceTransaction } = useQuery({
    ...BalanceTransaction.objects.paginateQueryFactory(paramsBalanceTransaction),
    enabled: !!id
  })

  const { data: dataBalanceTransactionDept } = useQuery({
    ...Balance.getBalanceDeptByCompanyId(params),
    enabled: !!id && !!month
  })

  const isCurrentOrFutureMonth = dayjs(month).isAfter(dayjs(), 'month') || dayjs(month).isSame(dayjs(), 'month')

  return (
    <BoxPage
      title={__('Balance Employer Detail')}
      showBackButton={true}
      breadcrumbs={[
        { label: __('Finance Management') },
        { label: __('Balance Management'), href: '/cms/finance/balance' },
        { label: __('Balance Employer Detail') }
      ]}
    >
      <div className='mb-[26px]'>
        <BalanceFilterBarDetail company={dataCompany?.data} refetch={refetchBalanceTransaction} />
      </div>
      {isCurrentOrFutureMonth ? (
        dataBalanceTransactionDept?.data?.status === 'pending' || !dataBalanceTransactionDept?.data?.status ? (
          <BalanceCompanyDetailCurrent dataCompare={dataBalanceStatisticsCompare?.data} idUrl={id} />
        ) : (
          <BalanceCompanyDetailPast
            dataBalance={dataBalanceStatistics?.data || []}
            dataBalanceTransaction={dataBalanceTransaction}
          />
        )
      ) : (
        <BalanceCompanyDetailPast
          dataBalance={dataBalanceStatistics?.data || []}
          dataBalanceTransaction={dataBalanceTransaction}
        />
      )}
    </BoxPage>
  )
}
